import script from "./DressCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./DressCarousel.vue?vue&type=script&setup=true&lang=js"

import "./DressCarousel.vue?vue&type=style&index=0&id=54e3ae16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e3ae16"]])

export default __exports__